export default __webpack_public_path__ + "static/media/diplomatIconEmpty.70546c7b.svg";